import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import {Field, reduxForm} from "redux-form";
import {sendEmail} from "../../actions/connectionActions";
import Paper from "@material-ui/core/Paper";
import ViewTitle from "../../components/ViewTitle";

const styles = theme => ({
  block: {
    display: 'block',
  },
  addUser: {
    marginRight: theme.spacing(1),
  },
  contentWrapper: {
    margin: '40px 16px',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
    padding: '15px',
    paddingTop: '40px',
    paddingBottom: '40px'
  },
  textField: {
    minWidth: "200px"
  }
});

class Invite extends React.Component {


  renderTextField = ({
                       input, label,
                       meta: {touched, invalid, error},
                       ...custom
                     }) => (
    <TextField
      style={{marginTop: '1px'}}
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && invalid && error}
      variant="outlined"
      margine="normal"
      fullWidth
      {...input}
      {...custom}
    />
  );

  submit = (formValues) => {
    this.props.sendEmail(formValues.email);
  };

  render() {
    const {classes, handleSubmit} = this.props;

    return (
      <React.Fragment>
        <Paper className={classes.paper}>
          <div className={classes.contentWrapper}>
            <ViewTitle>
              Invite
            </ViewTitle>
            <div className={classes.paper}>
              <form className={classes.form} onSubmit={handleSubmit(this.submit)}>
                <Grid container justify="center" alignItems="stretch" spacing={1} xs={12} style={{flexWrap: "nowrap"}}>
                  <Grid item xs justify="center" spacing={4}>
                    <Field
                      name="email"
                      label="Email"
                      id="standard-basic"
                      component={this.renderTextField}
                      className={classes.textField}
                    >
                    </Field>
                  </Grid>
                  <Grid item xs={2} alignItems="center" style={{flexWrap: "nowrap", padding: "4px"}}>
                    <Button
                      type="submit"
                      style={{height: '100%'}}
                      variant="contained" color="primary">
                      <Icon>send</Icon>
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </div>
          </div>
        </Paper>
      </React.Fragment>
    );
  }
};

Invite.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return ({
    error: state.error
  });
};

const mapDispatchToProps = dispatch => ({
  sendEmail: email => dispatch(sendEmail(email)),
});

Invite = withStyles(styles)(Invite);

Invite = connect(
  mapStateToProps,
  mapDispatchToProps
)(Invite);

Invite = reduxForm({
  form: 'Invite'
})(Invite);

export default Invite;
